var _path, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkerIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 27C10 27.5523 10.4477 28 11 28C11.5523 28 12 27.5523 12 27H10ZM22 27C22 27.5523 22.4477 28 23 28C23.5523 28 24 27.5523 24 27H22ZM23 18C22.4477 18 22 18.4477 22 19C22 19.5523 22.4477 20 23 20V18ZM23 12C22.4477 12 22 12.4477 22 13C22 13.5523 22.4477 14 23 14V12ZM28 27C28 27.5523 28.4477 28 29 28C29.5523 28 30 27.5523 30 27H28ZM24.5 21C23.9477 21 23.5 21.4477 23.5 22C23.5 22.5523 23.9477 23 24.5 23V21ZM12 27V26H10V27H12ZM15 23H19V21H15V23ZM22 26V27H24V26H22ZM19 16C19 17.1046 18.1046 18 17 18V20C19.2091 20 21 18.2091 21 16H19ZM17 18C15.8954 18 15 17.1046 15 16H13C13 18.2091 14.7909 20 17 20V18ZM15 16C15 14.8954 15.8954 14 17 14V12C14.7909 12 13 13.7909 13 16H15ZM17 14C18.1046 14 19 14.8954 19 16H21C21 13.7909 19.2091 12 17 12V14ZM25 16C25 17.1046 24.1046 18 23 18V20C25.2091 20 27 18.2091 27 16H25ZM23 14C24.1046 14 25 14.8954 25 16H27C27 13.7909 25.2091 12 23 12V14ZM28 26V27H30V26H28ZM24.5 23H25V21H24.5V23ZM30 26C30 23.2386 27.7614 21 25 21V23C26.6569 23 28 24.3431 28 26H30ZM19 23C20.6569 23 22 24.3431 22 26H24C24 23.2386 21.7614 21 19 21V23ZM12 26C12 24.3431 13.3431 23 15 23V21C12.2386 21 10 23.2386 10 26H12Z",
    fill: "#8697AB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 3.5,
    stroke: "#E9EBF4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerIcon);
export default __webpack_public_path__ + "static/media/worker_icon.d558a86c6884e68bfbd71d4b567e4c30.svg";
export { ForwardRef as ReactComponent };